/**
 * Store en memoria usado por los interceptores HTTP. La sesión normal se respalda además en
 * sessionStorage (ver portalSessionStorage.ts) para sobrevivir recargas dentro de la misma
 * pestaña; nunca se usa localStorage ni se comparte entre sesiones del navegador.
 */

interface TokenStorage {
  get(): string | null;
  set(token: string | null): void;
  clear(): void;
}

class InMemoryTokenStorage implements TokenStorage {
  private token: string | null = null;

  get(): string | null {
    return this.token;
  }

  set(token: string | null): void {
    this.token = token;
  }

  clear(): void {
    this.token = null;
  }
}

// Vite puede mantener instancias de módulos anteriores durante HMR y también puede
// resolver el mismo archivo desde aliases distintos (`@/auth/...` y rutas relativas).
// Guardar el store en globalThis garantiza que AuthContext y los clientes Axios compartan
// exactamente la misma sesión efímera sin persistir el JWT en el navegador.
type TildeGlobal = typeof globalThis & {
  __tildeTokenStorage?: TokenStorage;
};

const tildeGlobal = globalThis as TildeGlobal;

export const tokenStorage: TokenStorage =
  tildeGlobal.__tildeTokenStorage ??
  (tildeGlobal.__tildeTokenStorage = new InMemoryTokenStorage());
